import { Fragment, useEffect, useState } from 'react';

import { ChevronIcon } from 'components/icons';
import PropTypes from 'prop-types';
import styles from 'styles/LandingLocalitiesList.module.scss';
import { useMaxNumberItems } from './context/max-number-items-context';
import { useNumberItems } from './context/number-items-context';
import useRichTranslation from 'hooks/useRichTranslation';

const ViewMoreButton = ({
    initialNumberItems,
    deltaItems = 20,
    showAll = false
}) => {
    const t = useRichTranslation('localities-list');
    const [showButton, setShowButton] = useState(true);
    const [isAllItemsShowed, setAllItemsShowed] = useState(false);
    const { numberItems, setNumberItems } = useNumberItems();
    const { maxNumberItems } = useMaxNumberItems();

    useEffect(() => {
        if (maxNumberItems <= numberItems) {
            setAllItemsShowed(true);
        } else {
            setAllItemsShowed(false);
        }
    }, [numberItems, maxNumberItems]);

    useEffect(() => {
        if (maxNumberItems < initialNumberItems) {
            setShowButton(false);
        } else {
            setShowButton(true);
        }
    }, [maxNumberItems]);

    function viewMoreHandler () {
        if (showAll && !isAllItemsShowed) {
            setNumberItems(maxNumberItems);
        } else if (!isAllItemsShowed) {
            setNumberItems((st) => st + deltaItems);
        } else {
            setNumberItems((st) => initialNumberItems);
        }
    }

    return (
        <Fragment>
            {
                isAllItemsShowed && (
                    <div className={styles.space} />
                )
            }
            {
                showButton && (
                    <div className={styles.table_bottom}>
                        <button
                            className={styles.view_more_button}
                            onClick={viewMoreHandler}
                        >
                            {
                                !isAllItemsShowed ?
                                    (
                                        <p>{t('view-more')}</p>
                                    ) :
                                    (
                                        <p>{t('view-less')}</p>
                                    )
                            }
                            <ChevronIcon
                                fill="white"
                                width={15}
                                height={7.5}
                                direction={
                                    !isAllItemsShowed ? 'up' : 'down'
                                }
                            />
                        </button>
                    </div>
                )
            }
        </Fragment>
    );
};

ViewMoreButton.propTypes = {
    initialNumberItems: PropTypes.number.isRequired,
    showAll: PropTypes.bool,
    deltaItems: PropTypes.number
};

export default ViewMoreButton;
